window.theme.component('modal', () => {
    // Return if is in admin to prevent the block from breaking.
    if (typeof initializer !== 'undefined' && initializer.isAdmin) return;

    /**
     * Open the modal.
     */
    function open(modalId) {
        const modal = document.querySelector(`.js-modal[data-modal-id="${modalId}"]`);

        if (modal) {
            modal.classList.add('is-active');

            // Maybe play a video.
            const video = modal.querySelector('video, iframe');

            if (video) {
                if (video.tagName === 'VIDEO') {
                    video.play();
                } else if (video.tagName === 'IFRAME' && video.getAttribute('id') !== 'pdf-iframe') {
                    const videoUrl = new URL(video.dataset.src);
                    videoUrl.searchParams.set('autoplay', 1);
                    videoUrl.searchParams.set('mute', 0);

                    video.src = videoUrl;
                }
            }
        }
    }

    /**
     * Close the modal.
     */
    function close(modal) {
        modal.classList.remove('is-active');

        // Maybe pause a video.
        const video = modal.querySelector('video');

        if (video) {
            video.pause();
        }

        // Maybe disable an iframe.
        const iframe = modal.querySelector('iframe');

        if (iframe) {
            iframe.src = '';
        }
    }

    /**
     * Attach event listeners to modal triggers
     */
    const triggers = document.querySelectorAll('.js-modal-trigger');

    if (triggers) {
        triggers.forEach(function(trigger) {
            trigger.addEventListener('click', function() {
                const modalId = this.getAttribute('data-modal');

                if (modalId) {
                    open(modalId);
                }
            });
        });
    }

    /**
     * Attach event listeners to modal close buttons
     */
    const closeButtons = document.querySelectorAll('.js-modal-close');

    if (closeButtons) {
        closeButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                const modal = this.closest('.js-modal');

                if (modal) {
                    close(modal);
                }
            });
        });
    }
});